<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'

/**
 * Dashboard-1 Component
 */
export default {
  page: {
    title: 'Dashboard',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {  Layout },
  data() {
    return {     
      title: 'Inicio',
      items: [
        {
          text: 'REPODECAM',
          href: '/',
        },
        {
          text: 'Inicio',
          active: true,
        },
      ],
      state: {
        date: new Date(),
      },
    }
  },
}
</script>

<template>
  <Layout>
  
  
    <div class="row">
      
      <div class="col-xl-12">
        <div class="card-box">
          <h4 class="header-title mb-3">Inicio</h4>
          <!-- sales analytics chart -->
          <div>
            <img align="center" style="display: block;margin-left: auto;margin-right: auto;" src="@assets/images/sefin_principal.png" alt />
          </div>
          <!-- end chart -->
        </div>
        <!-- end card-box -->
      </div>
      <!-- end col-->
    </div>
  
  </Layout>
</template>
